import { render } from "./AttrMD.vue?vue&type=template&id=a7964bc2"
import script from "./AttrMD.vue?vue&type=script&lang=js"
export * from "./AttrMD.vue?vue&type=script&lang=js"

import "./AttrMD.vue?vue&type=style&index=0&id=a7964bc2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrMD.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a7964bc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a7964bc2', __exports__)) {
    api.reload('a7964bc2', __exports__)
  }
  
  module.hot.accept("./AttrMD.vue?vue&type=template&id=a7964bc2", () => {
    api.rerender('a7964bc2', render)
  })

}


export default __exports__